import { WeekDays } from '../types/WeekDays';

const getFormattedDay = (expectedDate: string): WeekDays => {
  const dayKey = new Date(expectedDate).toDateString().slice(0, 3).toLowerCase() as keyof typeof WeekDays;
  return WeekDays[dayKey];
};
const getFormattedDate = (expectedDate: string, countryFormat: string = 'fr-FR'): string => {
  const date = new Date(expectedDate).toLocaleDateString(countryFormat).replace(/\./g, '/');
  const dateParts = date.split('/');
  let firstPart = dateParts.shift();
  firstPart = firstPart.length < 2 ? `0${firstPart}` : firstPart;
  return [firstPart, ...dateParts].join('/');
};

const getNextYearDate = (date: Date = new Date()): string => {
  const d = new Date(date);
  d.setFullYear(d.getFullYear() + 1);

  let month = '' + (d.getMonth() + 1);
  let day = '' + d.getDate();
  const year = d.getFullYear();

  if (month.length < 2) month = '0' + month;
  if (day.length < 2) day = '0' + day;

  return [year, month, day].join('-');
};

/**
 * Extracts time in the format "hours:minutes:seconds" from an ISO date string.
 * @param {string} isoDate - The ISO date string.
 * @returns {string} The formatted time string "HH:MM:SS".
 */
function getFormattedTime(isoDate) {
  const date = new Date(isoDate);
  const hours = date.getUTCHours().toString().padStart(2, '0');
  const minutes = date.getUTCMinutes().toString().padStart(2, '0');
  const seconds = date.getUTCSeconds().toString().padStart(2, '0');
  return `${hours}:${minutes}:${seconds}`;
}
/**
 * Combines formatted date and time into a single string.
 * @param {string} isoDate - The ISO date string.
 * @param {string} countryFormat - The country format for the date (default is 'fr-FR').
 * @returns {string} The combined formatted date and time string "DD/MM/YYYY HH:MM:SS".
 */
const getFormattedDateAndTime = (isoDate: string, countryFormat: string = 'fr-FR'): string => {
  const formattedDate = getFormattedDate(isoDate, countryFormat);
  const formattedTime = getFormattedTime(isoDate);

  return `${formattedDate} ${formattedTime}`;
};

export { getFormattedDay, getFormattedDate, getNextYearDate, getFormattedTime, getFormattedDateAndTime };
